export default {
	PLAYLIST: 'PLAYLIST',
	SONG: 'SONG',
};
